module.exports = {"320621100":"海安镇","320621101":"城东镇","320621102":"曲塘镇","320621103":"李堡镇","320621105":"角斜镇","320621107":"大公镇","320621109":"雅周镇","320621111":"白甸镇","320621112":"南莫镇","320621113":"墩头镇","320621400":"海安县农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320621.json
// module id = 812
// module chunks = 0